// extracted by mini-css-extract-plugin
export default {"chat":"chat_chat__NYh7i"};